import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { blackBackArrowImage, chromeInstructions } from "../../assets";
import Chrome from "./components/Chrome/Chrome";
import Firefox from "./components/Firefox/Firefox";
import InternetExplorer from "./components/Internet-Exlorer/InternetExplorer";
import Opera from "./components/Opera/Opera";
import Safari from "./components/Safari/Safari";

function HowAllowLocation(props) {
  return (
    <>
      <section id="content-wrapper" className="content-wrapper calendar-page">
        <div className="container-fluid">
          <p className="small-text-bold page-title ">
            <img
              className="pointer-point"
              src={blackBackArrowImage}
              onClick={() => props.history.goBack()}
            />

            <span className="small-text-bold page-title">
              How Allow Location
            </span>
          </p>

          <div className="calendar-wrapper mt-40 mt-m-20 pb-30">
            <p
              className="small-font-size"
              //dangerouslySetInnerHTML={{ __html: data.about }}
            ></p>
            <div id="accordion">
              <div className="card rounded-box mb-4">
                <div className="card-header" id="headingOne">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link sub-title black-color pl-0"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Chrome
                    </button>
                  </h5>
                </div>

                <div
                  id="collapseOne"
                  className="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordion"
                >
                  <div
                    className="card-body small-font-size pt-0 "
                    //dangerouslySetInnerHTML={{ __html: data.contact_us }}
                  >
                    <Chrome />
                  </div>
                </div>
              </div>
              <div className="card rounded-box mb-4">
                <div className="card-header" id="headingTwo">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link collapsed sub-title black-color pl-0"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Safari
                    </button>
                  </h5>
                </div>
                <div
                  id="collapseTwo"
                  className="collapse"
                  aria-labelledby="headingTwo"
                  data-parent="#accordion"
                >
                  <div
                    className="card-body small-font-size pt-0"
                    //dangerouslySetInnerHTML={{ __html: data.faq }}
                  >
                    <Safari />
                  </div>
                </div>
              </div>
              <div className="card rounded-box mb-4">
                <div className="card-header" id="headingThree">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link collapsed sub-title black-color pl-0"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Firefox
                    </button>
                  </h5>
                </div>
                <div
                  id="collapseThree"
                  className="collapse"
                  aria-labelledby="headingThree"
                  data-parent="#accordion"
                >
                  <div
                    className="card-body small-font-size pt-0"
                    //dangerouslySetInnerHTML={{ __html: data.how_evom_work }}
                  >
                    <Firefox />
                  </div>
                </div>
              </div>
              <div className="card rounded-box mb-4">
                <div className="card-header" id="heading-cancellation-policy">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link collapsed sub-title black-color pl-0"
                      data-toggle="collapse"
                      data-target="#collapse-cancellation-policy"
                      aria-expanded="false"
                      aria-controls="cancellation-policy"
                    >
                      Opera
                    </button>
                  </h5>
                </div>
                <div
                  id="collapse-cancellation-policy"
                  className="collapse"
                  aria-labelledby="cancellation-policy"
                  data-parent="#accordion"
                >
                  <div className="card-body small-font-size pt-0">
                    <Opera />
                  </div>
                </div>
              </div>
              <div className="card rounded-box mb-4">
                <div className="card-header" id="heading-legal">
                  <h5 className="mb-0">
                    <button
                      className="btn btn-link collapsed sub-title black-color pl-0"
                      data-toggle="collapse"
                      data-target="#collapse-legal"
                      aria-expanded="false"
                      aria-controls="legal"
                    >
                      Microsoft Edge{" "}
                    </button>
                  </h5>
                </div>
                <div
                  id="collapse-legal"
                  className="collapse"
                  aria-labelledby="legal"
                  data-parent="#accordion"
                >
                  <div
                    className="card-body small-font-size pt-0"
                    //dangerouslySetInnerHTML={{ __html: data.legal }}
                  >
                    <InternetExplorer />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(HowAllowLocation);
